<template>
  <span>
      <span v-if="configurationLoad">
        <PapNavBar
          @hideSide="hideSide = $event"
          @attrSelected="attrSelected = $event"
          @returnClicked="returnClicked = $event"
          @flowChartTo="flowChartTo = $event"
          @openGoalSeek="openGoalSeek = $event"
          @openSensitivityAnalysis="openSensitivityAnalysis = $event"
          @editorMode="editorMode = $event"
          @executeSimulation="play($event)"
          @openRtoDrawer="showRtoDrawer = !showRtoDrawer"
          @openRtoAssistente="showRtoAssistente = true"
          :scenarioPeriod="scenarioPeriod"
          :yearPeriod="''"
          :revisionPeriod="''"
          :years="[]"
          :type="'PAP'"
          :updateInfoPCP="''">
        </PapNavBar>

        <div class="collumns" style="position: relative;">        
          <div class="collumnFlowChart" @mouseenter="hideSide">
            <Loading2 class="loading_productionPlan" caption="Aguarde..."></Loading2>
            <transition name="rto-banner">
              <div v-if="showRtoBanner" class="rto-applied-banner">
                <b-icon icon="check-circle-fill" class="rto-applied-banner__icon" />
                <span>Cenário otimizado aplicado<template v-if="rtoObjectiveLabel"> — {{ rtoObjectiveLabel }}</template></span>
                <button class="rto-applied-banner__close" @click="showRtoBanner = false">×</button>
              </div>
            </transition>

            <!-- Indicador flutuante de RTO em execução (CA-05.2) -->
            <transition name="rto-banner">
              <div v-if="rtoLastIteracao" class="rto-active-indicator">
                <div class="rto-active-indicator__header">
                  <b-icon icon="broadcast" class="rto-active-indicator__icon" />
                  <span class="rto-active-indicator__title">RTO em otimização</span>
                </div>
                <div class="rto-active-indicator__metrics">
                  <div>
                    <label>Iteração</label>
                    <span class="mono">{{ rtoLastIteracao.iteracao }}</span>
                  </div>
                  <div>
                    <label>Objetivo</label>
                    <span class="mono rto-active-indicator__objective">{{ formatRtoNum(rtoObjectiveValue) }}</span>
                  </div>
                  <div>
                    <label>Violações</label>
                    <span class="mono" :class="rtoLastIteracao.violacoes > 0 ? 'rto-active-indicator__danger' : 'rto-active-indicator__ok'">
                      {{ rtoLastIteracao.violacoes }}
                    </span>
                  </div>
                </div>
                <div class="rto-active-indicator__tags">
                  <span class="rto-active-indicator__tags-label">Tags impactadas ({{ rtoActiveTags.size }}):</span>
                  <div class="rto-active-indicator__tags-list">
                    <span v-for="tag in Array.from(rtoActiveTags).slice(0, 8)" :key="tag" class="rto-active-indicator__tag">
                      {{ tag }}
                    </span>
                    <span v-if="rtoActiveTags.size > 8" class="rto-active-indicator__tag rto-active-indicator__tag--more">
                      +{{ rtoActiveTags.size - 8 }}
                    </span>
                  </div>
                </div>
              </div>
            </transition>
            <PAP
              @sendInputList="callForSimulationByPAP($event)"
              :sendNodes="taskSimulation"
              :backFlowChart="returnClicked"
              :reloadNodes="objectStructure"
              :resetNodes="resetNodes"
              :flagEditMode="editorMode"
              :changeViewFlow="attrSelected"
              :flowchartTo="flowChartTo"
              :setLoading.sync="setLoading"
            />
          </div>
          
          <span class="right-left" v-if="enableLossScreen">
            <b-icon @click="openSide" icon="chevron-double-right" class="click-right rounded-circle bg-light"></b-icon>
            <b-icon @click="closeSide" icon="chevron-double-left" class="click-left rounded-circle bg-light"></b-icon>
            <b-icon @click="closeSide" @mouseenter="showSide" icon="chevron-double-left" class="click-left-stay rounded-circle bg-light"></b-icon>
          </span>
          <FormLossAndEfficiency
            class="form-loss"
            v-if="enableLossScreen"
            :update="callReloadNodes"
            :sendInputsToSimulation="this.taskSimulation"
            @sendInputList="callForSimulationByLossForm($event)"
          />

          <RtoConfigDrawer :visible="showRtoDrawer" @close="showRtoDrawer = false" />
          <RtoAssistentModal
            :visible="showRtoAssistente"
            @close="onRtoAssistenteClose"
            @apply="onRtoApply"
            @open-seq="onOpenSeq"
          />
          <RtoSeqMonitor
            :visible.sync="showRtoSeq"
            :processamentoId="rtoSeqProcessamentoId"
            :otimizacaoNome="rtoSeqOtimizacaoNome"
            :tagToLabel="rtoSeqTagToLabel"
            @iteracao="onSeqIteracao"
          />
        </div>
        
        <b-modal
          id="resultSimulation"
          size="lg"
          hide-footer
          :title="this.$t('simulacao-em-execucao')"
          :no-close-on-backdrop="true"
        >
          <SimulatorResult
            :result="result"
            @resultado="calculate($event, showLoading)"
            @closeSimulatiorResult="closeSimulatiorResult()"
            @stopSimulation="stopSimulation()"
          ></SimulatorResult>
        </b-modal>

        <b-modal id="goalSeekpap" size="xl" hide-footer :title="$t('atingir-metas')" :no-close-on-backdrop="true">
          <GoalSeek 
          :table="[]"
          :tableResultGoal="[]"
          @loadTableOutputGoal="loadTableOutput =$event"
          nameModel="goalSeekpap"
          ></GoalSeek>
        </b-modal>
          
        <b-modal id="openSensitivityAnalysisPap" size="lg" hide-footer :title="$t('analise-de-sensibilidade')" :no-close-on-backdrop="true">
          <SensitivityAnalysis 
          :table="[]"
          :tableResultSensitivityAnalysis="[]"
          @loadTableOutputSensitivityAnalysis="loadTableOutput =$event"
          nameModel="openSensitivityAnalysisPap">
          </SensitivityAnalysis>
        </b-modal>
      </span>
      <div v-else>
     {{ $t('loadConfigurations') }}
    </div>    
  </span>
</template>

<script>
import { openSide, closeSide, showSide, hideSide } from "../flowchart/utils/showAndHideSide"
import { SingletonEnginnering } from '../flowchart/nodes/_service/singletonEngineering';
import { SingletonAreas } from '../flowchart/nodes/_service/singletonAreas';
import { onEventBuss } from "@/global";
import { urlMainAPI } from "@/global";
import { PapMixin } from "../flowchart/utils/papMixin"
import { mapState } from "vuex";
import FormLossAndEfficiency from "./lossAndEfficiencyForm/formLossAndEfficiency.vue"
import RtoConfigDrawer from "./RtoConfigDrawer.vue"
import RtoAssistentModal from "./RtoAssistentModal.vue"
import RtoSeqMonitor from "../rto/RtoSeqMonitor.vue"
import SimulatorResult from "../productionPlanCreator/SimulatorResult.vue";
import PapNavBar from "./papNavBar"
import Loading2 from "../template/Loading2.vue";
import GoalSeek from '../goalSeek/GoalSeek';
import SensitivityAnalysis from '../sensitivityAnalysis/SensitivityAnalysis';
import axios from "axios";
import PAP from "../flowchart/PAP.vue";

let papContent = { onBussActivated: false, trySimulation: false }
const CancelToken = axios.CancelToken;
let executeRequest = CancelToken.source();
const refreshToken = () => {
  executeRequest = CancelToken.source();
};

export default {
  name: "PAPContent",

  components: {
    SimulatorResult,
    PAP,
    Loading2,
    PapNavBar,
    GoalSeek,
    FormLossAndEfficiency,
    SensitivityAnalysis,
    RtoConfigDrawer,
    RtoAssistentModal,
    RtoSeqMonitor,
  },

  computed: {
    ...mapState(["user"]),

    // Valor da variável objetivo na última iteração recebida do RTO.
    // O objetivo é sempre o primeiro output (outputMapping[0]); os demais são restrições.
    // Cada output vem como { valor, min, max, violado } — tolera payload antigo (número cru).
    rtoObjectiveValue() {
      const outputs = this.rtoLastIteracao?.outputs;
      if (!outputs) return null;
      const firstKey = Object.keys(outputs)[0];
      if (!firstKey) return null;
      const out = outputs[firstKey];
      return typeof out === 'object' && out !== null ? out.valor : out;
    },
  },

  mixins: [ PapMixin ],

  provide() {
    return {
      getTablesToGoalSeek: [],
      callCalculationSimulation: this.calculate,
      setStopSimulation: {
        stopStimulation: this.stopSimulation,
        executeRequest: executeRequest,
        refreshToken: refreshToken,
      },
      stateOfSimulation: this.stateOfSimulation,
      startSimulation: this.prepareForSimulation,
      showLoading: this.showLoading,
    };
  },

  data() {
    return {
      resetNodes: 0,
      startEditMode: 0,
      onSimulation: false,
      returnClicked: 0,
      openSide: openSide,
      closeSide: closeSide,
      showSide: showSide,
      hideSide: hideSide,
      editorMode: false,
      attrSelected: null,
      flowChartTo: "",
      openGoalSeek: 0,
      configurationLoad: false,
      setLoading: false,
      enableLossScreen: false,
      openSensitivityAnalysis :0,
      scenarioPeriod: null,
      loadingFromBackend: false,
      showRtoDrawer: false,
      showRtoAssistente: false,
      rtoApplied: false,
      rtoObjectiveLabel: '',
      showRtoBanner: false,
      // Tags em iteração ativa (recebidas via SignalR durante otimização)
      rtoActiveTags: new Set(),
      rtoActiveTagsClearTimer: null,
      rtoLastIteracao: null,
      // SEQ Monitor
      showRtoSeq: false,
      rtoSeqProcessamentoId: null,
      rtoSeqOtimizacaoNome: '',
      rtoSeqTagToLabel: {},
    };
  },

  watch: {
    openGoalSeek() {
      this.$bvModal.show("goalSeekpap");
    },
    openSensitivityAnalysis(){
      this.$bvModal.show("openSensitivityAnalysisPap");
    },
    callReloadNodes(val) {
      if (this.rtoApplied && val > 0) {
        this.rtoApplied = false;
        this.showRtoBanner = true;
        setTimeout(() => { this.showRtoBanner = false; }, 8000);
      }
    },
  },

  methods: {
    onRtoApply({ objectiveLabel } = {}) {
      this.rtoApplied = true;
      this.rtoObjectiveLabel = objectiveLabel || '';
      this.prepareForSimulation();
    },

    onSeqIteracao(payload) {
      // Recebe um payload SignalR do SEQ Monitor durante otimização.
      // Atualiza o indicador flutuante no flowchart com tags impactadas e métricas.
      const tags = new Set();
      const merge = obj => {
        if (!obj) return;
        for (const t of Object.keys(obj)) tags.add(t);
      };
      merge(payload?.inputs);
      merge(payload?.outputs);
      this.rtoActiveTags = tags;
      this.rtoLastIteracao = payload;
      if (this.rtoActiveTagsClearTimer) clearTimeout(this.rtoActiveTagsClearTimer);
      this.rtoActiveTagsClearTimer = setTimeout(() => {
        this.rtoActiveTags = new Set();
        this.rtoLastIteracao = null;
        this.rtoActiveTagsClearTimer = null;
      }, 4000);
    },

    onRtoAssistenteClose() {
      this.showRtoAssistente = false;
      // Mantém o indicador rodando se ainda há iterações chegando (timer de 4s cuida da limpeza)
    },

    onOpenSeq({ processamentoId, otimizacaoNome, tagToLabel }) {
      this.rtoSeqProcessamentoId = processamentoId;
      this.rtoSeqOtimizacaoNome = otimizacaoNome || '';
      this.rtoSeqTagToLabel = tagToLabel || {};
      this.showRtoSeq = true;
    },

    formatRtoNum(val) {
      if (val == null || isNaN(Number(val))) return '—';
      return Number(val).toLocaleString('pt-BR', { maximumFractionDigits: 4 });
    },

    callForSimulationByPAP(listOfInputNodes) {
      this.tableFlowChart = listOfInputNodes;
      this.papSent = true
    },

    callForSimulationByLossForm(listOfInput) {
      this.tableLossForm = listOfInput;
      this.formLossSent = true
    },

    waitAllReadyToSimulation() {
      if(this.papSent && (this.formLossSent || !this.enableLossScreen)) {
        papContent.trySimulation = false;
        this.executeSimulation();
        this.papSent = false;
        this.formLossSent = false;
      } else {
        if(papContent.trySimulation)
          setTimeout(this.waitAllReadyToSimulation, 250)
      }
    },

    prepareForSimulation() {
      papContent.trySimulation = true
      ++this.taskSimulation
      this.waitAllReadyToSimulation()
    },

    showLoading(show) {
      if(show)
        this.setLoading = null;
      this.setLoading = show
    },

    changeEditMode() {
      this.editorMode = !this.editorMode
    }, 

    async configurationIsLoaded() {
      if(SingletonEnginnering.isLoaded){
        this.configurationLoad = true;
        this.loadLossScreen();
        return;
      }
      else
        this.loadSingletonEnginnering();
      setTimeout(this.configurationIsLoaded, 1000)
    },

    async loadSingletonEnginnering() {
      let xml = localStorage.xml ? await JSON.parse(localStorage.xml) : "";
      if (xml && xml.scenarioObjectStructure && !SingletonEnginnering.isLoaded) {
        SingletonEnginnering.load(xml.scenarioObjectStructure);
        this.loadLossScreen();
      } else if (!SingletonEnginnering.isLoaded && !this.loadingFromBackend) {
        this.loadingFromBackend = true;
        const url = `${urlMainAPI}/loadactivesimulationscenario`;
        axios.get(url)
          .then((res) => {
            if (res.data && res.data.scenarioObjectStructure) {
              SingletonEnginnering.load(res.data.scenarioObjectStructure);
              const newXml = {
                name: res.data.name,
                scenario: res.data.scenario,
                scenarioResult: res.data.scenarioResult,
                scenarioObjectStructure: res.data.scenarioObjectStructure,
              };
              this.$store.commit("setXML", newXml);
              localStorage.setItem("xml", JSON.stringify(newXml));
              this.loadLossScreen();
            }
          })
          .catch()
          .finally(() => { this.loadingFromBackend = false; });
      }
    },

    async loadConfigurationPAP() {
      if (SingletonEnginnering.isLoaded) {
        if(!SingletonAreas.LoadedAreas())
          await SingletonAreas.LoadAreas(await this.loadAreas())
        this.showLoading(false);
      } else 
        setTimeout(() => this.loadConfigurationPAP(), 2000);
    },

    async loadAreas() {
      let areas = sessionStorage.areasFlowchart;
      if(!areas){
        const url = `${urlMainAPI}/getflowcharts`;
        await axios
          .get(url)
          .then((res) => {
            areas = res.data;
          })
          .catch();

          sessionStorage.areasFlowchart = JSON.stringify(areas)
        return areas
      }
        areas = JSON.parse(areas)
      return areas
    },

    async getEnable() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then((res) => 
        {
          this.enableLossScreen = !res.data.enableLossScreen
        }).catch();
    },

    loadLossScreen() {
      setTimeout(() => {
        let el = document.querySelector('.collumns');
        if (!this.enableLossScreen && el)
          el.style["grid-template-columns"] = "100%"
        else if (!this.enableLossScreen)
          this.loadLossScreen();
      }, 10);
    }
  },

  async created() {
    await this.getEnable();
    this.showLoading(true);
    if(!papContent.onBussActivated){
      onEventBuss("ExecuteSimulation", this.prepareForSimulation)
    }
    await this.configurationIsLoaded()
    this.showLoading(false);
    localStorage.setItem("xmlPeriod", localStorage.xmlPeriod != null ? localStorage.xmlPeriod : null);
    this.scenarioPeriod = localStorage.xmlPeriod;
  },
  

  beforeDestroy() {
    papContent.trySimulation = false;
  }
};
</script>

<style scoped>

SensitivityAnalysis
.form-loss {
  display: block;
}

.loading_productionPlan {
  display: none;
  align-items: center;
  position: fixed;
  top: 40%;
  left: 40%;
  height: 7%;
  width: 15%;
  min-width: 180px;
  min-height: 50px;
  z-index: 5;
  box-shadow: 3px 2px 7px #0008;
  background-color: rgba(255, 255, 255, 0.959);
  overflow: hidden !important;
}

.collumns {
  display: grid;
  grid-template-columns: 1fr 360px;
  width: 100%;
}

.rto-applied-banner {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #dcfce7;
  border: 1px solid #86efac;
  color: #166534;
  border-radius: 6px;
  padding: 8px 14px 8px 12px;
  font-size: 0.82rem;
  font-weight: 600;
  box-shadow: 0 2px 8px #0002;
  white-space: nowrap;
}

.rto-applied-banner__icon {
  font-size: 1rem;
  color: #16a34a;
  flex-shrink: 0;
}

.rto-applied-banner__close {
  background: none;
  border: none;
  cursor: pointer;
  color: #166534;
  font-size: 1rem;
  line-height: 1;
  padding: 0 0 0 6px;
  opacity: 0.6;
}

.rto-applied-banner__close:hover { opacity: 1; }

.rto-banner-enter-active { transition: opacity 300ms, transform 300ms; }
.rto-banner-leave-active { transition: opacity 500ms; }
.rto-banner-enter { opacity: 0; transform: translateX(-50%) translateY(-8px); }
.rto-banner-leave-to { opacity: 0; }

/* Indicador flutuante de RTO em execução (CA-05.2) */
.rto-active-indicator {
  position: fixed;
  top: 130px;
  right: 16px;
  width: 320px;
  max-width: calc(100% - 32px);
  background-color: rgba(31, 41, 55, 0.96);
  border-left: 4px solid #ff5f00;
  border-radius: 6px;
  padding: 12px 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  color: #f3f4f6;
  z-index: 2000;
  font-family: inherit;
  pointer-events: none;
}

.rto-active-indicator__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid #374151;
}

.rto-active-indicator__icon {
  color: #ff5f00;
  font-size: 1rem;
  animation: rto-pulse 1.5s ease-in-out infinite;
}

@keyframes rto-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.rto-active-indicator__title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #f9fafb;
}

.rto-active-indicator__metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #374151;
}

.rto-active-indicator__metrics > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rto-active-indicator__metrics label {
  font-size: 0.58rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.rto-active-indicator__metrics span {
  font-size: 0.95rem;
  font-weight: 600;
  color: #f3f4f6;
}

.rto-active-indicator__objective { color: #ff5f00 !important; }
.rto-active-indicator__ok { color: #4ade80 !important; }
.rto-active-indicator__danger { color: #f87171 !important; }

.rto-active-indicator__tags {
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rto-active-indicator__tags-label {
  font-size: 0.6rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.rto-active-indicator__tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.rto-active-indicator__tag {
  display: inline-block;
  padding: 2px 6px;
  background-color: #374151;
  color: #fed7aa;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.62rem;
  border-radius: 3px;
  border-left: 2px solid #ff5f00;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rto-active-indicator__tag--more {
  border-left-color: #9ca3af;
  color: #9ca3af;
}

.rto-active-indicator .mono {
  font-family: 'JetBrains Mono', 'SF Mono', Consolas, monospace;
}

.collumnFlowChart {
  display: block;
  grid-column-start: 1;
}

.right-left{
  position: absolute;
  cursor: pointer;
  top: 49%;
  right: 362px;
}

.click-left-stay,
.click-left{
  display: none;
}

.click-right{
  display: block;
}

.topSelect {
  display: grid;
  grid-row-start: 1;
  align-content: center;
}

.expand {
  position: absolute;
  top: 25px;
  right: 25px;
  border-radius: 5px;
  height: 40px;
}

#selectVar {
  width: 280px;
}

#loading {
  top: calc(50% + -100px);
  left: calc(50% + -224px);
}

.gridInput {
  grid-row-start: 2;
}

.gridOutput {
  grid-row-start: 3;
}

.groupBtn {
  grid-row-start: 4;
  border-top: 2px solid gray;
  margin-right: 5px;
}

.inputData {
  display: grid;
  margin: auto;
}

.imgData {
  width: 45px;
}

.footerButtons {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  grid-row-start: 4;
  margin-top: 10px;
}

.footerButtons img {
  justify-content: flex-end;
  cursor: pointer;
  margin-left: 30px;
  max-height: 35px;
}

.imgPAP {
  height: 100%;
  width: 100%;
}

@media (max-width: 1200px) {
  #expand,
  #collpse,
  .right-left {
    display: none;
  }

  .form-loss{
    display: none !important;
  }

  .collumns {
    grid-template-columns: 100% !important;
    grid-column-gap: 0px;
  }

  .topSelect {
    justify-self: center;
    width: 394px;
    grid-column-start: 1;
  }

  .gridInput {
    grid-column-start: 1;
    grid-row-start: 2;
    margin: 0px 10px;
  }

  .gridOutput {
    grid-column-start: 2;
    grid-row-start: 2;
    margin: 0px 10px;
  }

  .groupBtn {
    margin-top: 10px;
    grid-column-end: span 2;
    grid-row-start: 3;
  }
}
</style>